import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useItems, useAllDataLoader } from '../context/DataContext';
import './Home.css';

function Home() {
  const { data: items, loading } = useItems();
  const { refreshAllData } = useAllDataLoader();
  const [stockSummary, setStockSummary] = useState([]);

  useEffect(() => {
    // Calculate stock summary from items
    if (items && items.length > 0) {
      setStockSummary(items);
    }
  }, [items]);
  // Calculate statistics
  const totalItems = stockSummary.length;
  const totalPackets = stockSummary.reduce((sum, item) => sum + (item.numberOfPackets || 0), 0);
  const totalWeight = stockSummary.reduce((sum, item) => sum + (item.totalWeight || 0), 0);
  const lowStockItems = stockSummary.filter(item => item.numberOfPackets < 5 && item.numberOfPackets > 0).length;
  const outOfStockItems = stockSummary.filter(item => item.numberOfPackets === 0).length;

  const stats = [
    { label: 'Total Items', value: totalItems, icon: '📦', color: '#3498db' },
    { label: 'Total Packets', value: totalPackets, icon: '📋', color: '#27ae60' },
    { label: 'Total Weight', value: `${totalWeight.toFixed(2)} g`, icon: '⚖️', color: '#f39c12' },
    { label: 'Low Stock', value: lowStockItems, icon: '⚠️', color: '#e67e22' },
    { label: 'Out of Stock', value: outOfStockItems, icon: '❌', color: '#e74c3c' },
  ];

  const quickActions = [
    { to: '/add-stock', label: 'Add New Item', icon: '➕', color: '#27ae60' },
    { to: '/add-stock', label: 'Add Stock', icon: '📥', color: '#3498db' },
    { to: '/subtract-stock', label: 'Subtract Stock', icon: '📤', color: '#e74c3c' },
    { to: '/view-stock', label: 'View Stock', icon: '👁️', color: '#9b59b6' },
  ];

  const getStatus = (packets) => {
    if (packets === 0) return { label: 'Out of Stock', className: 'out-of-stock' };
    if (packets < 5) return { label: 'Low Stock', className: 'low-stock' };
    return { label: 'In Stock', className: 'in-stock' };
  };

  if (loading) {
    return <div className="loading">Loading stock data...</div>;
  }

  return (
    <div className="home-page">
      <div className="home-header">
        <h1 className="page-title">Welcome to Stock Management System</h1>
        <p className="page-description">Manage your inventory efficiently with real-time tracking</p>
        <button onClick={refreshAllData} className="btn btn-primary" style={{ marginTop: '10px' }}>
          🔄 Refresh Data
        </button>
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderLeftColor: stat.color }}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          {quickActions.map((action, index) => (
            <Link key={index} to={action.to} className="action-card">
              <div className="action-icon" style={{ background: action.color }}>
                {action.icon}
              </div>
              <div className="action-label">{action.label}</div>
            </Link>
          ))}
        </div>
      </div>

      {/* Recent Activity */}
      <div className="recent-activity">
        <h2>Stock Overview</h2>
        <div className="recent-items">
          {stockSummary.length === 0 ? (
            <p className="no-data">No items in stock. Start by adding your first item!</p>
          ) : (
            stockSummary.slice(0, 5).map((item, index) => {
              const status = getStatus(item.numberOfPackets);
              return (
                <div key={item.id || index} className="recent-item">
                  <div className="item-info">
                    <span className="item-name">{item.itemName}</span>
                    <span className="item-code">{item.itemCode}</span>
                    <span className="item-size">{item.size}</span>
                  </div>
                  <div className="item-stock">
                    <span className="packets">{item.numberOfPackets} packets</span>
                    <span className="weight">{item.totalWeight?.toFixed(2) || '0'} g</span>
                    <span className={`status-badge ${status.className}`}>
                      {status.label}
                    </span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;